<template>
  <div class="container-xl px-4 lots-page">
    <div class="row">
      <div class="col-12">
        <div class="page-header-mobile d-flex justify-content-between align-items-center mb-3 mt-2">
          <h2 class="fw-bold mb-0 page-title-mobile">Gestión de Lotes</h2>
          <button class="btn btn-dark d-flex align-items-center btn-mobile-primary">
            <i class="bi bi-plus-lg me-2"></i> Nuevo Lote
          </button>
        </div>
      </div>
    </div>

    <div class="mobile-context-chip d-lg-none">
      <span class="mobile-context-label">Catálogo e Inventario</span>
      <strong>Lotes</strong>
    </div>

    <div class="lots-scope-note">
      <strong>Alcance actual:</strong> esta pantalla sigue trabajando con datos de ejemplo y una acción de detalle placeholder. La optimización mobile se aplica sobre esa implementación parcial.
    </div>

    <div class="bg-white rounded shadow-sm p-4 d-none d-lg-block">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Código Lote</th>
              <th>Producto</th>
              <th>Fecha Producción</th>
              <th>Fecha Vencimiento</th>
              <th>Stock Actual</th>
              <th>Depósito</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lot in pagedLots" :key="lot.id">
              <td>{{ lot.code }}</td>
              <td>{{ lot.product }}</td>
              <td>{{ lot.productionDate }}</td>
              <td>{{ lot.expirationDate || '-' }}</td>
              <td>{{ lot.stock }}</td>
              <td>{{ lot.deposit }}</td>
              <td>
                <span
                  class="badge rounded-pill px-3 py-2"
                  :class="lot.status === 'Por Vencer' ? 'bg-danger text-white' : 'bg-dark text-white'"
                >
                  {{ lot.status }}
                </span>
              </td>
              <td>
                <button class="btn btn-outline-secondary btn-sm">Ver Detalle</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <AppPagination
        class="mt-3"
        :current-page="currentPage"
        :total-pages="totalPages"
        @page-changed="changePage"
      />
    </div>

    <div class="mobile-lot-list d-lg-none">
      <div v-if="pagedLots.length === 0" class="mobile-empty-state">
        <i class="bi bi-box2"></i>
        <span>Sin lotes visibles</span>
      </div>
      <div v-else v-for="lot in pagedLots" :key="`mobile-${lot.id}`" class="mobile-lot-card">
        <div class="mobile-lot-top">
          <div>
            <p class="mobile-lot-code">{{ lot.code }}</p>
            <h3 class="mobile-lot-name">{{ lot.product }}</h3>
          </div>
          <span
            class="badge rounded-pill px-3 py-2"
            :class="lot.status === 'Por Vencer' ? 'bg-danger text-white' : 'bg-dark text-white'"
          >
            {{ lot.status }}
          </span>
        </div>

        <div class="mobile-lot-meta">
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Producción</span>
            <strong>{{ lot.productionDate }}</strong>
          </div>
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Vencimiento</span>
            <strong>{{ lot.expirationDate || '-' }}</strong>
          </div>
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Stock</span>
            <strong>{{ lot.stock }}</strong>
          </div>
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Depósito</span>
            <strong>{{ lot.deposit }}</strong>
          </div>
        </div>

        <div class="mobile-lot-actions">
          <button class="btn btn-outline-secondary btn-sm">Ver Detalle</button>
        </div>
      </div>

      <AppPagination
        class="mt-3"
        :current-page="currentPage"
        :total-pages="totalPages"
        @page-changed="changePage"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import AppPagination from '@/components/AppPagination.vue'

const lots = ref([
  {
    id: 1,
    code: 'LOTO001',
    product: 'Medicamento A',
    productionDate: '2023-08-15',
    expirationDate: '2024-02-15',
    stock: 25,
    deposit: 'Farmacia',
    status: 'Por Vencer',
  },
  {
    id: 2,
    code: 'LOTO002',
    product: 'Alimento B',
    productionDate: '2023-12-01',
    expirationDate: '2024-06-01',
    stock: 150,
    deposit: 'Almacén Central',
    status: 'Vigente',
  },
  {
    id: 3,
    code: 'LOTO003',
    product: 'Producto Sin Vencimiento',
    productionDate: '2024-01-10',
    expirationDate: '',
    stock: 75,
    deposit: 'Almacén Central',
    status: 'Vigente',
  }
]);

const currentPage = ref(1)
const itemsPerPage = ref(5)

const totalPages = computed(() =>
  Math.ceil(lots.value.length / itemsPerPage.value)
)

const pagedLots = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  return lots.value.slice(start, start + itemsPerPage.value)
})

watch(lots, () => { currentPage.value = 1 })

function changePage(page) {
  if (page < 1 || page > totalPages.value) return
  currentPage.value = page
}
</script>

<style scoped>
.lots-page {
  max-width: 1400px;
}

.page-title-mobile {
  font-size: clamp(1.35rem, 2vw, 1.8rem);
}

.mobile-context-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  background: #f3f4f6;
  color: #111827;
  font-size: 0.82rem;
}

.mobile-context-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.lots-scope-note {
  margin-bottom: 1rem;
  padding: 0.9rem 1rem;
  border: 1px solid #dbeafe;
  border-radius: 1rem;
  background: #eff6ff;
  color: #1e3a8a;
}

.mobile-lot-list {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.mobile-lot-card {
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.06);
}

.mobile-lot-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
  margin-bottom: 0.85rem;
}

.mobile-lot-code {
  margin: 0 0 0.3rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
}

.mobile-lot-name {
  margin: 0;
  font-size: 1rem;
  line-height: 1.35;
  color: #0f172a;
}

.mobile-lot-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.mobile-meta-item {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.75rem 0.85rem;
  border-radius: 0.85rem;
  background: #fff;
  border: 1px solid #e5e7eb;
}

.mobile-meta-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.mobile-lot-actions {
  display: flex;
  gap: 0.65rem;
  margin-top: 0.95rem;
}

.mobile-lot-actions .btn {
  width: 100%;
}

.mobile-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 2.5rem 1rem;
  border: 1px dashed #cbd5e1;
  border-radius: 1rem;
  background: #f8fafc;
  color: #64748b;
}

@media (max-width: 991.98px) {
  .page-header-mobile {
    align-items: stretch !important;
    flex-direction: column;
    gap: 0.85rem;
  }

  .btn-mobile-primary {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .lots-page {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .mobile-lot-top {
    flex-direction: column;
  }

  .mobile-lot-meta {
    grid-template-columns: 1fr;
  }
}
</style>
